export default __webpack_public_path__ + "static/media/MockUp_Book2-02.ee4d89b3.jpg";